import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const fetchScreenViews = async () => {
  const res = await axios.get(`${API_URL}/screen-views`, header());
  return res.data;
};

export const fetchScreenView = async (id) => {
  const res = await axios.get(`${API_URL}/screen-views/${id}`, header());
  return res.data;
};

export const createScreenView = async (data) => {
  const res = await axios.post(`${API_URL}/screen-views`, data, header());
  return res.data;
};

export const updateScreenView = async (id, data) => {
  const res = await axios.put(`${API_URL}/screen-views/${id}`, data, header());
  return res.data;
};

export const deleteScreenView = async (id) => {
  await axios.delete(`${API_URL}/screen-views/${id}`, header());
};

export default {
  fetchScreenViews,
  fetchScreenView,
  createScreenView,
  updateScreenView,
  deleteScreenView,
};
